<nb-card class="control-report-list-dialog">
  <nb-card-header class="header">
    <img src="assets/images/risk-report.jpg" alt="RISK" class="risk-indicator-image" />
    <div class="title">{{ "asset_form_drawer.compliance.control_report.list_title" | translate }}</div>
    <div class="header-actions">
      <span class="close-btn" (click)="cancel()">
        <i class="fa-light fa-x"></i>
      </span>
    </div>
  </nb-card-header>
  <nb-card-body class="body">
    <div class="form-group">
      @if (loading) {
        <div class="loading-container">
          <nb-spinner size="medium"></nb-spinner>
        </div>
      } @else {
        @for (report of reports; track report.id) {
          <div class="report-item">
            <div class="report-content">
              <div class="report-name">{{ report.label || '-' }}</div>
              <div class="report-details">
                <div class="report-date">{{ formatDate(report.date) }}</div>
                <div class="report-linked">{{ getLinkedEquipmentText(report) }}</div>
              </div>
            </div>
            <div class="report-action">
              <button 
                nbButton 
                [status]="isAlreadyLinked(report) ? 'basic' : 'success'"
                [disabled]="isAlreadyLinked(report)"
                (click)="attachReport(report)"
                class="attach-btn">
                {{ isAlreadyLinked(report) ? ("asset_form_drawer.compliance.control_report.already_linked_short" | translate) : ("asset_form_drawer.compliance.control_report.attach" | translate) }}
              </button>
            </div>
          </div>
        }
        @if (reports.length === 0) {
          <div class="form-field empty-state">
            <div class="field-value">
              {{ "asset_form_drawer.compliance.control_report.no_reports_available" | translate }}
            </div>
          </div>
        }
      }
    </div>
  </nb-card-body>
</nb-card>

